import {
  commonValidationSchemas,
  createValidationSchema,
} from 'infrastructure/functions';

export const clinicCareManagersValidationSchema = () =>
  createValidationSchema({
    careManagers: commonValidationSchemas.array(
      commonValidationSchemas.string({ nullable: true }),
    ),
  });
